import axios from "axios";
import { useEffect, useState } from "react";
import PropertyItem from "../property-item/property-item.component";
import Spinner from "../../components/spinner/spinner.component";
import { API_URL } from "../../shared/constant";
import { Link } from "react-router-dom";
import Pagination from "../pagination/pagination";
import classnames from "classnames";
let PageSize = 9;
const PropertiesList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [propertiesItems, setpropertiesItems] = useState(null);
  let [loading, setLoading] = useState(true);
  let [listView, setListView] = useState(false);

  useEffect(() => {
    const getProperties = async () => {
      await axios
        .get(`${API_URL.PROPERTY}?limit=${PageSize}&page=${currentPage}`)
        .then((response) => {
          if (response.status === 200) {
            setpropertiesItems(response.data.data);
            setTotalCount(response.data.total_records);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("Error from PropertiesList");
        });
    };

    getProperties();
  }, [currentPage]);

  let listContent;

  if (loading) {
    listContent = <Spinner />;
  } else if (propertiesItems.length === 0) {
    listContent = <div className="list-msg">ℹ️ No property available</div>;
  } else {
    listContent = propertiesItems.map((property) => (
      <PropertyItem
        key={property.property_id}
        property={property}
        listView={listView}
      />
    ));
  }

  return (
    <div className="col-lg-12">
      <div className="row align-items-center mb-4">
        <div className="col-lg-6">
          <div className="breadcrumb_content style1 mb0-991 mt-1">
            <h2 className="breadcrumb_title">All Property</h2>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="listing_list_style mb20-xsd tal-991">
            <ul className="mb0">
              <li
                className={classnames("list-inline-item", {
                  active: !listView,
                })}
                onClick={() => setListView(false)}
              >
                <Link>
                  <span className="fa fa-th-large"></span>
                </Link>
              </li>
              <li
                className={classnames("list-inline-item", {
                  active: listView,
                })}
                onClick={() => setListView(true)}
              >
                <Link>
                  <span className="fa fa-th-list"></span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={listView ? "row" : "row property-grid-view"}>
        {listContent}

        <div className="col-lg-12 mt20">
          <div className="mbp_pagination">
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertiesList;
